export const SET_CURRENT_EVENT = "SET_CURRENT_EVENT";
export const SET_SELECTED_EVENT = "SET_SELECTED_EVENT";
